import React from 'react';

const BookingOverlay = () => {
    const closeOverlay = () => {
        const overlay = document.querySelector('.js-bookings-overlay');
        overlay.classList.remove('is-active');
    }

    return (
        <div className='overlay js-bookings-overlay'>
            <div onClick={closeOverlay} className="close-btn"></div>
        </div>
    );
};

export default BookingOverlay;